import { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Table from "../../Components/Expenses/PayableRentTable";
import { IoFilter } from "react-icons/io5";
import SideModal from "../../Components/SideModal";
import moment from "moment";
import DateFilterModal from "../../Components/Expenses/PayableRentFilterModal";
import { useLocation } from "react-router-dom";

const PayableRent = () => {
    const location = useLocation();
    const totalRent = location.state?.totalRent;

    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const btnRef = useRef(null);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [activeFilter, setActiveFilter] = useState(null);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [startDate, setStartDate] = useState(1);
    const [endDate, setEndDate] = useState(31);
    const getCurrentMonthDates = () => {
        const start = 1;
        const end = 31;
        return { start, end };
    };

    const fetchFunction = async () => {
        let url = `${Config.apiUrl}/landlord/list?startDate=${startDate}&endDate=${endDate}`;

        const response = await axios.get(url, {
            headers: {
                authorization: "Bearer " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess) {
            setApiData(res.landlords);
            setIsFocused(true);
        }
    };

    const getError = (err) => {
        toast.error(err?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        isRefetching,
        data,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        if (startDate && endDate) {
            getListMutate();
        }
    }, [startDate, endDate]);

    const handleApplyFilter = (selectedValue) => {
        const [start, end] = selectedValue.split('-').map(Number);

        setStartDate(start);
        setEndDate(end);
        setActiveFilter({ value: selectedValue, label: selectedValue });
        setIsFilterApplied(true);
        setIsFilterOpen(false);
    };
    const handleClearFilters = () => {
        const { start, end } = getCurrentMonthDates();
        setStartDate(start);
        setEndDate(end);
        setActiveFilter(null);
        setIsFilterApplied(false);
        setIsFilterOpen(false);
    };

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Payable Rent
                    <Underline />
                </BoxTitle>
            </BoxHead>

            <SideModal
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
            >
                <DateFilterModal
                    onApplyFilter={handleApplyFilter}
                    handleClose={() => setIsFilterOpen(false)}
                    currentFilter={activeFilter}
                    handleClearFilters={handleClearFilters}
                />
            </SideModal>

            <FilterTableWrapper>
                <FilterWrapper>
                    <div className="flex items-center">
                        <Text>
                            Total Payable Rent:{" "}
                            <span className="font-semibold">
                                {totalRent || 0}
                            </span>
                        </Text>
                    </div>
                    <div className="flex gap-2 justify-end items-center ml-auto">

                        <div className="relative">
                            <FilterBtn
                                ref={btnRef}
                                type="button"
                                title="Date Filter"
                                onClick={() => setIsFilterOpen((v) => !v)}
                            >
                                <IoFilter size={14} color="#9CA3AF" />
                                {isFilterApplied && (
                                    <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                                )}
                            </FilterBtn>
                        </div>
                    </div>
                </FilterWrapper>

                {!error && !isLoading && data && (
                    <TableWrapper>
                        <Table
                            apiData={apiData || []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                        />
                        {(!apiData || apiData.length === 0) && <NotFoundModel />}
                    </TableWrapper>
                )}
            </FilterTableWrapper>

            {error && !isLoading && <NotFoundModel />}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const Text = tw.p`text-gray-500 text-sm font-normal `;
export default PayableRent;